import { request } from '@/services/apiClient';
import type { AppNotification, NotificationPreference } from '../types';

const NOTIFICATIONS = '/v1/notifications';

export const notificationApi = {
	/** Newest first; `cursor` is the `createdAt` of the last item already loaded. */
	list(
		query: { unread?: boolean; limit: number; cursor?: string },
		signal?: AbortSignal,
	): Promise<AppNotification[]> {
		const params = new URLSearchParams({ limit: String(query.limit) });
		if (query.unread) params.set('unread', 'true');
		if (query.cursor) params.set('cursor', query.cursor);
		return request<AppNotification[]>({
			url: `${NOTIFICATIONS}?${params.toString()}`,
			method: 'GET',
			signal,
		});
	},

	unreadCount(signal?: AbortSignal): Promise<{ count: number }> {
		return request<{ count: number }>({
			url: `${NOTIFICATIONS}/unread-count`,
			method: 'GET',
			signal,
		});
	},

	markRead(id: string): Promise<void> {
		return request<void>({
			url: `${NOTIFICATIONS}/${encodeURIComponent(id)}/read`,
			method: 'POST',
		});
	},

	markAllRead(): Promise<void> {
		return request<void>({ url: `${NOTIFICATIONS}/read-all`, method: 'POST' });
	},

	getPreferences(signal?: AbortSignal): Promise<NotificationPreference[]> {
		return request<NotificationPreference[]>({
			url: `${NOTIFICATIONS}/preferences`,
			method: 'GET',
			signal,
		});
	},

	updatePreferences(
		preferences: NotificationPreference[],
	): Promise<NotificationPreference[]> {
		return request<NotificationPreference[]>({
			url: `${NOTIFICATIONS}/preferences`,
			method: 'PUT',
			data: { preferences },
		});
	},
};
